import React from 'react'
import { graphql, Link } from 'gatsby'
import clsx from 'clsx'

import './button.scss'

export const Button = ({
  label = '',
  variant = 'primary',
  otherClasses,
  form,
  external,
  slug,
  onClick,
}) => {
  const buttonClasses = clsx(
    otherClasses,
    variant === 'primary' &&
      `px-6 py-3 rounded-full text-base font-bold leading-6 font-Gentium-Plus text-[#453E2C] bg-primary_biege_600 hover:text-[#5605EC] hover:outline hover:outline-[2px] hover:outline-[#5605EC]`,
    variant === 'secondary' &&
      `px-6 py-3 rounded-full text-base font-bold leading-6 font-Gentium-Plus outline outline-[2px] outline-primary_biege_600 text-primary_biege_600 hover:text-[#453E2C] hover:outline-[0px] bg-transparent hover:bg-primary_biege_600`,
    variant === 'text-link' &&
      `text-base font-Mulish font-bold leading-6 flex items-center gap-2 text-primary_biege_600 hover:text-[#5605EC] group`
  )

  const withIcon = variant === 'text-link'

  if (slug) {
    const { current } = slug
    return (
      <>
        {external ? (
          <a
            className={buttonClasses}
            href={current}
            target="_blank"
            rel="noopener noreferrer"
          >
            {label}
            {withIcon && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="8"
                viewBox="0 0 38 8"
                fill="none"
              >
                <path
                  d="M32.972 7.55914L36.9265 4.39546C37.0576 4.29058 37.1312 4.14833 37.1312 4C37.1312 3.85168 37.0576 3.70942 36.9265 3.60454L32.972 0.440858C32.8742 0.3624 32.7496 0.308922 32.6139 0.287203C32.4781 0.265484 32.3372 0.276502 32.2094 0.31886C32.0815 0.361219 31.9721 0.43301 31.8952 0.525132C31.8184 0.617255 31.7775 0.72556 31.7776 0.836318L31.7786 3.44082L0 3.44003V4.55997L31.7786 4.55918L31.7776 7.16368C31.7775 7.27444 31.8184 7.38275 31.8952 7.47487C31.9721 7.56699 32.0815 7.63878 32.2094 7.68114C32.3372 7.7235 32.4781 7.73452 32.6139 7.7128C32.7496 7.69108 32.8742 7.6376 32.972 7.55914Z"
                  className="fill-[#DED7C7] group-hover:fill-[#5605EC]"
                />
              </svg>
            )}
          </a>
        ) : (
          <Link
            className={buttonClasses}
            to={`/${current}`}
            target="_self"
            rel=""
          >
            {label}
            {withIcon && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="8"
                viewBox="0 0 38 8"
                fill="none"
              >
                <path
                  d="M32.972 7.55914L36.9265 4.39546C37.0576 4.29058 37.1312 4.14833 37.1312 4C37.1312 3.85168 37.0576 3.70942 36.9265 3.60454L32.972 0.440858C32.8742 0.3624 32.7496 0.308922 32.6139 0.287203C32.4781 0.265484 32.3372 0.276502 32.2094 0.31886C32.0815 0.361219 31.9721 0.43301 31.8952 0.525132C31.8184 0.617255 31.7775 0.72556 31.7776 0.836318L31.7786 3.44082L0 3.44003V4.55997L31.7786 4.55918L31.7776 7.16368C31.7775 7.27444 31.8184 7.38275 31.8952 7.47487C31.9721 7.56699 32.0815 7.63878 32.2094 7.68114C32.3372 7.7235 32.4781 7.73452 32.6139 7.7128C32.7496 7.69108 32.8742 7.6376 32.972 7.55914Z"
                  className="fill-[#DED7C7] group-hover:fill-[#5605EC]"
                />
              </svg>
            )}
          </Link>
        )}
      </>
    )
  }

  return (
    <button
      onClick={(e) => {
        onClick && onClick(form, e)
      }}
      className={buttonClasses}
      data-testid="button"
    >
      {label}
      {withIcon && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="8"
          viewBox="0 0 38 8"
          fill="none"
        >
          <path
            d="M32.972 7.55914L36.9265 4.39546C37.0576 4.29058 37.1312 4.14833 37.1312 4C37.1312 3.85168 37.0576 3.70942 36.9265 3.60454L32.972 0.440858C32.8742 0.3624 32.7496 0.308922 32.6139 0.287203C32.4781 0.265484 32.3372 0.276502 32.2094 0.31886C32.0815 0.361219 31.9721 0.43301 31.8952 0.525132C31.8184 0.617255 31.7775 0.72556 31.7776 0.836318L31.7786 3.44082L0 3.44003V4.55997L31.7786 4.55918L31.7776 7.16368C31.7775 7.27444 31.8184 7.38275 31.8952 7.47487C31.9721 7.56699 32.0815 7.63878 32.2094 7.68114C32.3372 7.7235 32.4781 7.73452 32.6139 7.7128C32.7496 7.69108 32.8742 7.6376 32.972 7.55914Z"
            className="fill-[#DED7C7] group-hover:fill-[#5605EC]"
          />
        </svg>
      )}
    </button>
  )
}

export default Button

export const query = graphql`
  fragment Button on SanityButton {
    label
    variant
    action
    external
    form
    slug {
      current
    }
  }
`
